import {createSlice} from "@reduxjs/toolkit";
import {setExceedsNonPrimaryVolumeStatisticsSearchPageFilter} from "./actions";
import {ExceedsNonPrimaryVolumeStatisticsSearchCriteria} from "@ots-frontend/ots-data";

type ExceedsNonPrimaryVolumeStatisticsSearchPageState = {
  filter?: ExceedsNonPrimaryVolumeStatisticsSearchCriteria
}

const INITIAL_STATE: Readonly<ExceedsNonPrimaryVolumeStatisticsSearchPageState> = {
  filter: undefined,
};

const exceedsNonPrimaryVolumeStatisticsSearchPageSlice = createSlice({
  name: "ui/exceeds-non-primary-volume-statistics-search-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setExceedsNonPrimaryVolumeStatisticsSearchPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
  }
});

export const exceedsNonPrimaryVolumeStatisticsSearchPageReducer = exceedsNonPrimaryVolumeStatisticsSearchPageSlice.reducer;
